/**
 * Extends jQuery UI Dialog to:
 *  - disable auto-focus on open.
 *  - allow for links to be generated in the button bar.
 *  
 * Usage:
 *   $('#div').suzyDialog({
 *   	noAutoFocus: true,  						// <-- extension
 *   	buttons: {
 *   		'Ok': function(){
 *   			$(this).dialog('close')
 *   		},
 *   		'More': {
 *   			isLink: true,						// <-- extension
 *   			href: 'http://example.com/more'
 *   		}
 *   	},
 *   	titleTabs: true								// <-- extension
 *   });
 */
(function($) {
	$.widget('ui.suzyDialog', $.extend($.ui.dialog.prototype, {
		
		titleTabsInitialized: false,
		
        open: function() {
                if (this._isOpen) { return; }

                var self = this,
                        options = self.options,
                        uiDialog = self.uiDialog;

                self.overlay = options.modal ? new $.ui.dialog.overlay(self) : null;
                self._size();
                self._position(options.position);
                uiDialog.show(options.show);
                self.moveToTop(true);

                // prevent tabbing out of modal dialogs
                if (options.modal) {
                        uiDialog.bind('keypress.ui-dialog', function(event) {
                                if (event.keyCode !== $.ui.keyCode.TAB) {
                                        return;
                                }

                                var tabbables = $(':tabbable', this),
                                        first = tabbables.filter(':first'),
                                        last  = tabbables.filter(':last');

                                if (event.target === last[0] && !event.shiftKey) {
                                        first.focus(1);
                                        return false;
                                } else if (event.target === first[0] && event.shiftKey) {
                                        last.focus(1);
                                        return false;
                                }
                        });
                }

                if(!options.noAutoFocus){
	                // set focus to the first tabbable element in the content area or the first button
	                // if there are no tabbable elements, set focus on the dialog itself
	                $(self.element.find(':tabbable').get().concat(
	                        uiDialog.find('.ui-dialog-buttonpane :tabbable').get().concat(
	                                uiDialog.get()))).eq(0).focus();
                }
                
                if(options.titleTabs && !this.titleTabsInitialized){
                	this._initTitleTabs();
                	this.titleTabsInitialized = true;
                }
                
                self._isOpen = true;
                self._trigger('open');

                return self;
        },
	
        _createButtons: function(buttons) {
    		var self = this,
    			hasButtons = false,
    			uiDialogButtonPane = $('<div></div>')
    				.addClass(
    					'ui-dialog-buttonpane ' +
    					'ui-widget-content ' +
    					'ui-helper-clearfix'
    				),
    			uiButtonSet = $( "<div></div>" )
    				.addClass( "ui-dialog-buttonset" )
    				.appendTo( uiDialogButtonPane );

    		// if we already have a button pane, remove it
    		self.uiDialog.find('.ui-dialog-buttonpane').remove();

    		if (typeof buttons === 'object' && buttons !== null) {
    			$.each(buttons, function() {
    				return !(hasButtons = true);
    			});
    		}
    		if (hasButtons) {
    			$.each(buttons, function(name, props) {
    				if(props.isLink){
						var link = $('<a>'+(props.text ? props.text : name)+'</a>')
								   .attr(props, true)
								   .appendTo(uiButtonSet);
    				}else{
	    				props = $.isFunction( props ) ?
	    					{ click: props, text: name } :
	    					props;
	    				var button = $('<button type="button"></button>')
	    					.attr( props, true )
	    					.unbind('click')
	    					.click(function() {
	    						props.click.apply(self.element[0], arguments);
	    					})
	    					.appendTo(uiButtonSet);
	    				if ($.fn.button) {
	    					button.button();
	    				}
    				}
    			});
    			uiDialogButtonPane.appendTo(self.uiDialog);
    		}
    	},
    	
		_initTitleTabs: function(){
			var self = this;
			
			var tabsElement;
			if(this.element.hasClass('ui-tabs')){
				tabsElement = this.element;
			}else{
				return;
			}
			
			self.element.addClass('has-title-tabs');
			
			var onTabsChange = function(event, ui){
				var selectedTabIndex = tabsElement.tabs('option', 'selected');
				if(ui){
					selectedTabIndex = ui.index;
				}
				
				var tabLinks = tabsElement.find('.ui-tabs-nav a');
				
				var titleParts = [];
				tabLinks.each(function(i){
					var label = $(this).text();
					var href = $(this).attr('href');
					var isSelected = i == selectedTabIndex;
					if(isSelected){
						titleParts.push('<span class="title-tab">'+label+'</span>');
					}else{
						titleParts.push('<a class="title-tab" href="'+href+'" forTabIndex="'+i+'">'+label+'</a>');
					}
				});
				var title = '<span class="title-tabs">' + titleParts.join(' | ') + '</span>';
				
				self._setOption('title', title);

				self.uiDialogTitlebar.find('a.title-tab').click(function(e){
					e.preventDefault();
					var selectTab = parseInt($(this).attr('forTabIndex'));
					tabsElement.tabs('select', selectTab);
				});
			};
			tabsElement.bind('tabsselect', onTabsChange);
			onTabsChange();
		}
		
	}));
})(jQuery);